import { createVNode as a, mergeProps as n } from "vue";
import l from "../node_modules/@pf-ui/pf-icon-svg/es/asn/FileExcelTwotoneStandard.js";
import i from "../components/PfIcon.js";
const e = (t, o) => {
  const r = {
    ...t,
    ...o.attrs
  };
  return a(i, n(r, {
    icon: l
  }), null);
};
e.displayName = "FileExcelTwotoneStandard";
e.inheritAttrs = !1;
export {
  e as default
};
